import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetOrderedSubgenresQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
}>;

export type GetOrderedSubgenresQuery = {
	__typename?: 'Query';
	genres: Array<{
		__typename?: 'Genre';
		id: string;
		translation: string;
		technicalName: string;
		shortName: string;
		subgenreMovies: Array<{
			__typename?: 'GenericTitleList';
			id: string;
			content: {
				__typename?: 'GenericTitleListContent';
				name: string;
				fullPath?: string | null;
				shortName?: string | null;
				moviesUrl?: { __typename?: 'Url'; fullPath: string } | null;
				showsUrl?: { __typename?: 'Url'; fullPath: string } | null;
			};
		}>;
		subgenreShows: Array<{
			__typename?: 'GenericTitleList';
			id: string;
			content: {
				__typename?: 'GenericTitleListContent';
				name: string;
				fullPath?: string | null;
				shortName?: string | null;
				moviesUrl?: { __typename?: 'Url'; fullPath: string } | null;
				showsUrl?: { __typename?: 'Url'; fullPath: string } | null;
			};
		}>;
	}>;
	subgenres: Array<{
		__typename?: 'GenericTitleList';
		id: string;
		content: {
			__typename?: 'GenericTitleListContent';
			name: string;
			fullPath?: string | null;
			shortName?: string | null;
			moviesUrl?: { __typename?: 'Url'; fullPath: string } | null;
			showsUrl?: { __typename?: 'Url'; fullPath: string } | null;
		};
	}>;
};

export type GetSubgenresQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
}>;

export type GetSubgenresQuery = {
	__typename?: 'Query';
	subgenres: Array<{
		__typename?: 'GenericTitleList';
		id: string;
		content: {
			__typename?: 'GenericTitleListContent';
			name: string;
			fullPath?: string | null;
			shortName?: string | null;
			moviesUrl?: { __typename?: 'Url'; fullPath: string } | null;
			showsUrl?: { __typename?: 'Url'; fullPath: string } | null;
		};
	}>;
};

export type SubgenreFragment = {
	__typename?: 'GenericTitleListContent';
	name: string;
	fullPath?: string | null;
	shortName?: string | null;
	moviesUrl?: { __typename?: 'Url'; fullPath: string } | null;
	showsUrl?: { __typename?: 'Url'; fullPath: string } | null;
};

export const SubgenreFragmentDoc = gql`
	fragment Subgenre on GenericTitleListContent {
		name
		fullPath
		shortName
		moviesUrl {
			fullPath
		}
		showsUrl {
			fullPath
		}
	}
`;
export const GetOrderedSubgenresDocument = gql`
	query GetOrderedSubgenres($country: Country!, $language: Language!) {
		genres {
			id
			translation(language: $language)
			technicalName
			shortName
			subgenreMovies: subgenres(objectType: "movie") {
				id
				content(country: $country, language: $language) {
					...Subgenre
				}
			}
			subgenreShows: subgenres(objectType: "show") {
				id
				content(country: $country, language: $language) {
					...Subgenre
				}
			}
		}
		subgenres(objectType: "movie", country: $country) {
			id
			content(country: $country, language: $language) {
				...Subgenre
			}
		}
	}
	${SubgenreFragmentDoc}
`;
export const GetSubgenresDocument = gql`
	query GetSubgenres($country: Country!, $language: Language!) {
		subgenres(objectType: "movie", country: $country) {
			id
			content(country: $country, language: $language) {
				...Subgenre
			}
		}
	}
	${SubgenreFragmentDoc}
`;
